const routes = [
  {
    index: true,
    label: 'Marcus Gray',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Web sites',
    path: '/projects',
  },
  {
    label: 'Stats',
    path: '/stats',
  },
  {
    label: 'AI',
    path: 'AI',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
